var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FullscreenFrontageDialog',{ref:"frontageDialog"},[[_c('UnsavedChangesConfirmation',{attrs:{"show":true,"subject":_vm.subject},on:{"onCloseButtonClicked":_vm.handleClose,"onCancelClicked":_vm.handleClose,"onOkClicked":_vm.handleSubmit}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }